import {IS_LOGIN, ON_LOGIN} from "../Actions/loginAction"

const initialState = {
    isUserLogin: false,
    user: null,
    permission: null,
    customer: null,
    wallet: 0,
    whiteLabel: null
}

const loginReducer = (state = initialState, action) =>{
    switch (action.type) {
        case IS_LOGIN:
            return {
                ...state,
                isUserLogin: action.payload
            }

        case ON_LOGIN:
            return {
                ...state,
                user: action.payload
            }
        default:
            return state;
    }
}

export default loginReducer